"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCloseMenusLinkClick = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = require("react");
const menu_hooks_1 = require("./menu.hooks");
const useCloseMenusLinkClick = (link) => {
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const closeMenus = (0, menu_hooks_1.useCloseAllMenus)();
    const { localeHref } = (0, epic_games_nav_shared_1.getHrefWithLocale)(Object.assign(Object.assign({}, link), { locale }));
    return (0, react_1.useCallback)((e) => {
        closeMenus();
        if (link) {
            if (link.useCustomCallback) {
                if (link.onClick && typeof link.onClick === "function") {
                    link.onClick(e);
                }
                else {
                    e.preventDefault();
                    (0, epic_games_nav_shared_1.navigateWithHref)(localeHref, locale);
                }
            }
            else if (!link.useCustomCallback && link.onClick && typeof link.onClick === "function") {
                link.onClick(e);
            }
        }
        else {
            console.warn("[EGH] invalid link passed without an onClick or an href value", link);
        }
    }, [closeMenus, epic_games_nav_shared_1.navigateWithHref, localeHref, link, link === null || link === void 0 ? void 0 : link.useCustomCallback, link === null || link === void 0 ? void 0 : link.onClick]);
};
exports.useCloseMenusLinkClick = useCloseMenusLinkClick;
//# sourceMappingURL=click.hooks.js.map